var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { compare } from 'fast-json-patch';
import produce from 'immer';
import { cloneDeep, isEqual, set, uniqueId } from 'lodash';
import React, { Component, useContext } from 'react';
import { merge, Subject } from 'rxjs';
import { concatMap, debounceTime, throttleTime } from 'rxjs/operators';
import { ValidationError } from 'yup';
import { convertValidationResultToErrorsObject, isDomainValidationError, toNullableKeys } from '../../Shared/DomainValidationFunctions';
import { convertObjectToBooleans, convertObjectToString } from '../../Shared/Types';
import { StyledNavigationPrompt } from '../Prompts/StyledNavigationPrompt';
import { MetaFormContext } from './MetaForm';
export var FormContext = React.createContext({
    id: 'empty-context-form',
    lastValidSavedFormValues: {},
    formValues: {},
    errors: {},
    formHasErrors: false,
    dirty: {},
    touched: {},
    formIsDirty: false,
    formWasTouched: false,
    submitting: false,
    failedToSave: false,
    onBulkChange: function () { return undefined; },
    onChange: function () { return function () { return undefined; }; },
    setFormValues: function () { return undefined; },
    setErrors: function () { return undefined; },
    submitForm: function () { return Promise.resolve(); },
    fullFormValidate: function () { return Promise.resolve({}); },
    fieldChanges: new Subject()
});
export var useAutosaveForm = function () {
    // Yes a double convert. Yes it's weird. It's a work around since we can't easily make generic contexts in react.
    var form = useContext(FormContext);
    return {
        form: form
    };
};
export var AutosaveOperations;
(function (AutosaveOperations) {
    AutosaveOperations[AutosaveOperations["Put"] = 0] = "Put";
    AutosaveOperations[AutosaveOperations["Patch"] = 1] = "Patch";
})(AutosaveOperations || (AutosaveOperations = {}));
function isFormValid(errors) {
    return Object.values(errors).every(function (it) { return it === ''; });
}
function formHasErrorsOnDirtyFields(touched, errors) {
    return Object.entries(errors).some(function (_a, index) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return value !== '' && touched[key] === true;
    });
}
function convertValidationErrorsToErrorObject(err) {
    var errorsObject = {};
    err.inner.forEach(function (error) {
        set(errorsObject, error.path, error.message);
    });
    return errorsObject;
}
var AutosaveForm = /** @class */ (function (_super) {
    __extends(AutosaveForm, _super);
    function AutosaveForm(props) {
        var _this = _super.call(this, props) || this;
        _this.submission$$ = null;
        _this.activateSubmitting$$ = null;
        _this.fullFormValidate = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.setState({
                            touched: convertObjectToBooleans(_this.state.formValues, true)
                        }, function () { return __awaiter(_this, void 0, void 0, function () {
                            var errors;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.validateForm(this.state.formValues)];
                                    case 1:
                                        errors = _a.sent();
                                        this.triggerValidationEvents(this.state.touched, errors);
                                        this.formUpdated();
                                        resolve(errors);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    })];
            });
        }); };
        _this.setErrors = function (errors) {
            _this.setState({
                errors: errors
            }, function () {
                _this.formUpdated();
            });
        };
        _this.onFieldChanged = function (field, newValue) {
            _this.state.fieldChanges.next({
                field: field,
                value: newValue,
                formValues: _this.state.formValues
            });
        };
        _this.onBulkChange = function (newValues, config) {
            var fields = Object.entries(newValues);
            if (fields.length) {
                if (_this.props.onSubmitting)
                    _this.props.onSubmitting();
                _this.setState(function (state) {
                    return produce(state, function (draftState) {
                        fields.forEach(function (_a) {
                            var _b = __read(_a, 2), field = _b[0], newValue = _b[1];
                            set(draftState.formValues, field, newValue);
                            var newValueIsDifferent = !isEqual(newValue, state.lastValidSavedFormValues[field]);
                            set(draftState.dirty, field, newValueIsDifferent);
                            set(draftState.touched, field, true);
                            set(draftState.errors, field, '');
                        });
                    });
                }, function () {
                    fields.forEach(function (_a) {
                        var _b = __read(_a, 2), field = _b[0], newValue = _b[1];
                        _this.onFieldChanged(field, newValue);
                    });
                    if (config === null || config === void 0 ? void 0 : config.instantSubmit) {
                        _this.submission$.next();
                    }
                    else {
                        _this.debouncedSubmission$.next();
                    }
                    _this.formUpdated();
                });
            }
        };
        _this.onChange = function (field) { return function (newValue, config) {
            if (_this.props.onSubmitting)
                _this.props.onSubmitting();
            _this.setState(function (state) {
                return produce(state, function (draftState) {
                    set(draftState.formValues, field, newValue);
                    var newValueIsDifferent = !isEqual(newValue, state.lastValidSavedFormValues[field]);
                    set(draftState.dirty, field, newValueIsDifferent);
                    set(draftState.touched, field, true);
                    set(draftState.errors, field, '');
                });
            }, function () {
                _this.onFieldChanged(field, newValue);
                if (config === null || config === void 0 ? void 0 : config.instantSubmit) {
                    _this.submission$.next();
                }
                else {
                    _this.debouncedSubmission$.next();
                }
                _this.formUpdated();
            });
        }; };
        _this.setFormValues = function (_a) {
            var values = _a.values, dirty = _a.dirty, touched = _a.touched, errors = _a.errors;
            if (_this.props.onSubmitting)
                _this.props.onSubmitting();
            _this.setState(function (state) {
                return produce(state, function (draftState) {
                    draftState.formValues = values;
                    if (dirty)
                        draftState.dirty = dirty;
                    if (touched)
                        draftState.touched = touched;
                    if (errors)
                        draftState.errors = errors;
                });
            }, function () {
                _this.debouncedSubmission$.next();
                _this.formUpdated();
            });
        };
        _this.triggerValidationEvents = function (touched, errors) {
            var hasFormErrors = _this.formHasErrors(touched, errors);
            if (hasFormErrors) {
                if (_this.props.onValidationError) {
                    _this.props.onValidationError(errors, _this.submitForm);
                }
            }
            else {
                if (_this.props.onValidationSuccess) {
                    _this.props.onValidationSuccess();
                }
            }
        };
        _this.formMatchesLastSaved = function () {
            if (!!_this.props.readOnly)
                return true;
            var newFormValues = _this.state.formValues;
            var lastValidSavedFormValues = _this.state.lastValidSavedFormValues;
            return isEqual(newFormValues, lastValidSavedFormValues);
        };
        _this.doFormPatch = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var mapFormToPatchContract, newFormValues, lastValidSavedFormValues, validationErrors, invalidFields, submittedFields, safeToSaveFormValues, baselineContract, newFormContract, patch, patchResult, dirtFields, touchedFields, err_1, formStructure, patchValidationError;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    mapFormToPatchContract = this.props.mapFormToAPIContract;
                                    newFormValues = this.state.formValues;
                                    lastValidSavedFormValues = this.state.lastValidSavedFormValues;
                                    return [4 /*yield*/, this.validateForm(newFormValues)];
                                case 1:
                                    validationErrors = _a.sent();
                                    invalidFields = new Set();
                                    submittedFields = new Set();
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 6, , 7]);
                                    safeToSaveFormValues = produce(newFormValues, function (newFormValuesDraft) {
                                        Object.entries(newFormValuesDraft).forEach(function (_a) {
                                            var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                            if (validationErrors.hasOwnProperty(key) && validationErrors[key] !== '') {
                                                // Don't submit a field if it's errored
                                                // Instead use the last good value to calculate the difference.
                                                invalidFields.add(key);
                                                newFormValuesDraft[key] = lastValidSavedFormValues[key];
                                            }
                                            else {
                                                if (newFormValues[key] !== lastValidSavedFormValues[key]) {
                                                    submittedFields.add(key);
                                                }
                                            }
                                        });
                                    });
                                    baselineContract = mapFormToPatchContract(lastValidSavedFormValues, lastValidSavedFormValues);
                                    newFormContract = mapFormToPatchContract(safeToSaveFormValues, lastValidSavedFormValues);
                                    patch = compare(baselineContract, newFormContract);
                                    if (!(patch.length !== 0)) return [3 /*break*/, 4];
                                    if (this.props.onSubmitting)
                                        this.props.onSubmitting();
                                    return [4 /*yield*/, this.props.serverCallback(patch)];
                                case 3:
                                    patchResult = _a.sent();
                                    if (this.props.onSubmitted)
                                        this.props.onSubmitted(safeToSaveFormValues, patchResult, submittedFields);
                                    return [3 /*break*/, 5];
                                case 4:
                                    console.info('No patch required, no changes detected');
                                    _a.label = 5;
                                case 5:
                                    dirtFields = produce(this.state.dirty, function (draftDirty) {
                                        Object.entries(draftDirty).forEach(function (_a) {
                                            var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                            if (submittedFields.has(key)) {
                                                draftDirty[key] = false;
                                            }
                                        });
                                    });
                                    touchedFields = produce(this.state.touched, function (draftTouchedFields) {
                                        Object.entries(draftTouchedFields).forEach(function (_a) {
                                            var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                            if (submittedFields.has(key)) {
                                                draftTouchedFields[key] = false;
                                            }
                                        });
                                    });
                                    this.setState({
                                        submitting: false,
                                        dirty: dirtFields,
                                        touched: touchedFields,
                                        errors: validationErrors,
                                        lastValidSavedFormValues: safeToSaveFormValues,
                                        failedToSave: false
                                    }, function () {
                                        _this.formUpdated();
                                    });
                                    this.triggerValidationEvents(touchedFields, validationErrors);
                                    return [3 /*break*/, 7];
                                case 6:
                                    err_1 = _a.sent();
                                    console.error('Unable to submit form - errors: ', err_1);
                                    if (isDomainValidationError(err_1)) {
                                        formStructure = toNullableKeys(this.state.formValues);
                                        patchValidationError = convertValidationResultToErrorsObject({
                                            result: err_1.content,
                                            formStructure: formStructure
                                        });
                                        validationErrors = Object.assign({}, validationErrors, patchValidationError.formErrors);
                                    }
                                    if (this.props.onSubmitError)
                                        this.props.onSubmitError(err_1, this.submitForm, submittedFields);
                                    this.setState({
                                        submitting: false,
                                        errors: validationErrors,
                                        failedToSave: true
                                    }, function () {
                                        _this.formUpdated();
                                    });
                                    this.triggerValidationEvents(this.state.touched, validationErrors);
                                    return [3 /*break*/, 7];
                                case 7:
                                    resolve();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        }); };
        _this.setFormTouched = function () {
            _this.setState({
                touched: convertObjectToBooleans(_this.state.formValues, true)
            });
        };
        _this.doFormPut = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var mapFormToPatchContract, newFormValues, lastValidSavedFormValues, validationErrors, isValid, patchedFields, newFormContract, putResult, dirtyFields, touchedFields, err_2;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    mapFormToPatchContract = this.props.mapFormToAPIContract;
                                    newFormValues = cloneDeep(this.state.formValues);
                                    lastValidSavedFormValues = this.state.lastValidSavedFormValues;
                                    this.setFormTouched();
                                    return [4 /*yield*/, this.validateForm(newFormValues)];
                                case 1:
                                    validationErrors = _a.sent();
                                    isValid = isFormValid(validationErrors);
                                    if (!isValid) {
                                        this.setState({
                                            submitting: false,
                                            errors: validationErrors,
                                            failedToSave: true
                                        }, function () {
                                            _this.formUpdated();
                                        });
                                        this.triggerValidationEvents(this.state.touched, validationErrors);
                                        return [2 /*return*/, resolve()];
                                    }
                                    patchedFields = new Set(Object.keys(newFormValues));
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, , 5]);
                                    newFormContract = mapFormToPatchContract(newFormValues, lastValidSavedFormValues);
                                    if (this.props.onSubmitting)
                                        this.props.onSubmitting();
                                    return [4 /*yield*/, this.props.serverCallback(newFormContract)];
                                case 3:
                                    putResult = _a.sent();
                                    if (this.props.onSubmitted)
                                        this.props.onSubmitted(newFormValues, putResult, patchedFields);
                                    dirtyFields = this.getAllFieldsClean();
                                    touchedFields = this.getAllFieldsNotTouched();
                                    this.setState({
                                        submitting: false,
                                        dirty: dirtyFields,
                                        touched: touchedFields,
                                        errors: validationErrors,
                                        lastValidSavedFormValues: newFormValues,
                                        failedToSave: false
                                    }, function () {
                                        _this.formUpdated();
                                    });
                                    this.triggerValidationEvents(touchedFields, validationErrors);
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_2 = _a.sent();
                                    console.error('Unable to submit form - errors: ', err_2);
                                    if (this.props.onSubmitError)
                                        this.props.onSubmitError(err_2, this.submitForm, patchedFields);
                                    this.setState({
                                        submitting: false,
                                        errors: validationErrors,
                                        failedToSave: true
                                    }, function () {
                                        _this.formUpdated();
                                    });
                                    this.triggerValidationEvents(this.state.touched, validationErrors);
                                    return [3 /*break*/, 5];
                                case 5:
                                    resolve();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        }); };
        _this.getAllFieldsNotTouched = function () {
            return convertObjectToBooleans(_this.props.mapGetContractToForm(_this.props.initialContractValue));
        };
        _this.getAllFieldsClean = function () {
            return convertObjectToBooleans(_this.props.mapGetContractToForm(_this.props.initialContractValue));
        };
        _this.getAllFieldsNoErrors = function () {
            return convertObjectToString(_this.props.mapGetContractToForm(_this.props.initialContractValue));
        };
        _this.getFormValuesFromInitialContract = function () {
            return _this.props.validationSchema.cast(_this.props.mapGetContractToForm(_this.props.initialContractValue));
        };
        _this.submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.autosaveOperation === AutosaveOperations.Put) {
                    console.info('Doing put operation');
                    return [2 /*return*/, this.doFormPut()];
                }
                else if (this.props.autosaveOperation === AutosaveOperations.Patch) {
                    console.info('Doing patch operation');
                    return [2 /*return*/, this.doFormPatch()];
                }
                return [2 /*return*/];
            });
        }); };
        _this.manualFormSubmit = function () {
            _this.submission$.next();
            return _this.submission$.toPromise();
        };
        _this.validateForm = function (newFormValues) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var err_3, errorsObject_1, newState_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.props.validationSchema.validate(newFormValues, {
                                            strict: false,
                                            abortEarly: false,
                                            stripUnknown: false,
                                            recursive: true
                                        })];
                                case 1:
                                    _a.sent();
                                    this.setState({
                                        errors: this.getAllFieldsNoErrors()
                                    }, function () {
                                        _this.formUpdated();
                                        resolve(_this.getAllFieldsNoErrors());
                                    });
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_3 = _a.sent();
                                    console.warn('Autosave form validation failed');
                                    if (err_3 instanceof ValidationError && err_3.inner && err_3.inner.length) {
                                        errorsObject_1 = convertValidationErrorsToErrorObject(err_3);
                                        newState_1 = produce(this.state, function (draft) {
                                            draft.errors = errorsObject_1;
                                        });
                                        this.setState(newState_1, function () {
                                            _this.formUpdated();
                                            resolve(newState_1.errors);
                                        });
                                    }
                                    else {
                                        resolve(this.state.errors);
                                    }
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        }); };
        _this.submission$ = new Subject();
        _this.debouncedSubmission$ = new Subject();
        var initialFormValues = _this.getFormValuesFromInitialContract();
        _this.state = {
            id: uniqueId('autosave-form-'),
            lastValidSavedFormValues: initialFormValues,
            formValues: initialFormValues,
            submitting: false,
            errors: _this.getAllFieldsNoErrors(),
            dirty: _this.getAllFieldsClean(),
            touched: _this.getAllFieldsNotTouched(),
            failedToSave: false,
            onBulkChange: _this.onBulkChange,
            onChange: _this.onChange,
            fieldChanges: new Subject(),
            setFormValues: _this.setFormValues,
            setErrors: _this.setErrors,
            submitForm: _this.manualFormSubmit,
            fullFormValidate: _this.fullFormValidate
        };
        return _this;
    }
    AutosaveForm.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!!this.props.shouldFormUpdateFromProps &&
            this.props.shouldFormUpdateFromProps(prevProps.initialContractValue, this.props.initialContractValue)) {
            var formValues = this.getFormValuesFromInitialContract();
            this.setState({
                formValues: formValues
            }, function () {
                _this.formUpdated();
                return _this.submitForm();
            });
        }
    };
    AutosaveForm.prototype.componentDidMount = function () {
        var _this = this;
        this.activateSubmitting$$ = merge(this.submission$, this.debouncedSubmission$).subscribe(function () {
            var formsEqual = _this.formMatchesLastSaved();
            if (!formsEqual)
                _this.setState({
                    submitting: true,
                    failedToSave: false
                }, function () {
                    _this.formUpdated();
                });
        });
        this.submission$$ = merge(this.submission$.pipe(throttleTime(50)), this.debouncedSubmission$.pipe(debounceTime(750)))
            .pipe(concatMap(this.submitForm))
            .subscribe(function () {
            console.log('Submission stream coming in');
        });
        var context = this.context;
        context.registerForm(this);
    };
    AutosaveForm.prototype.componentWillUnmount = function () {
        if (this.submission$$ && this.submission$$.unsubscribe)
            this.submission$$.unsubscribe();
        if (this.activateSubmitting$$ && this.activateSubmitting$$.unsubscribe)
            this.activateSubmitting$$.unsubscribe();
        var context = this.context;
        context.removeForm(this.state.id);
    };
    AutosaveForm.prototype.render = function () {
        var renderState = this.getFormRenderValues();
        var displayNavigationPrompt = this.state.submitting || renderState.formIsDirty;
        // Another work around to make it strongly typed.
        var RenderContext = FormContext;
        return (React.createElement(RenderContext.Provider, { value: renderState },
            this.props.render(renderState),
            !!this.props.children && this.props.children(renderState),
            React.createElement(StyledNavigationPrompt, { when: displayNavigationPrompt })));
    };
    AutosaveForm.prototype.getFormHasErrors = function () {
        return this.formHasErrors(this.state.touched, this.state.errors);
    };
    AutosaveForm.prototype.getFormWasTouched = function () {
        return Object.values(this.state.touched).some(function (it) { return it === true; });
    };
    AutosaveForm.prototype.getFormIsDirty = function () {
        return Object.values(this.state.dirty).some(function (it) { return it === true; });
    };
    AutosaveForm.prototype.getFormRenderValues = function () {
        var formIsDirty = this.getFormIsDirty();
        var formWasTouched = this.getFormWasTouched();
        var formHasErrors = this.getFormHasErrors();
        var renderState = __assign(__assign({}, this.state), { formIsDirty: formIsDirty, formWasTouched: formWasTouched, formHasErrors: formHasErrors });
        return renderState;
    };
    AutosaveForm.prototype.formUpdated = function () {
        var context = this.context;
        context.updateForm(this.state.id);
    };
    AutosaveForm.prototype.formHasErrors = function (touched, errors) {
        return this.props.autosaveOperation === AutosaveOperations.Put
            ? !isFormValid(errors)
            : formHasErrorsOnDirtyFields(touched, errors);
    };
    AutosaveForm.contextType = MetaFormContext;
    return AutosaveForm;
}(Component));
export { AutosaveForm };
